import { createContext } from 'react';

export const ProfileContext = createContext();

export const ClientContext = createContext();

export const ExpertContext = createContext();

export const ToastContext = createContext();
